import { useAuthToken } from '@shared/stores/authToken'
import { rolePermissions } from '@shared/utils/permissions'

export const usePermissions = () => {
  const userRolesString = useAuthToken().getRoles || ''
  const userRoles = userRolesString.split(',')

  const hasPermission = (permission) => {
    return userRoles.some((role) => rolePermissions[role]?.[permission])
  }

  const canOpenMarket = () => hasPermission('canOpenMarket')
  const canViewPlatformLogs = () => hasPermission('canViewPlatformLogs')

  //OPERATION
  const canCreatedData = () => hasPermission('canCreatedData')
  const canDeleteData = () => hasPermission('canDeleteData')
  const canEditData = () => hasPermission('canEditData')
  const canManageOperation = () => hasPermission('canManageOperation')
  const canEditSensitiveInput = () => hasPermission('canEditSensitiveInput')
  const canViewOperationLogs = () => hasPermission('canViewOperationLogs')

  //MENU
  const canViewDashboard = () => hasPermission('canViewDashboard')
  const canViewTargetTaxes = () => hasPermission('canViewTargetTaxes')
  const canViewPreOperations = () => hasPermission('canViewPreOperations')
  const canViewPostOperations = () => hasPermission('canViewPostOperations')
  const canViewCompletedOperations = () => hasPermission('canViewCompletedOperations')
  const canViewClients = () => hasPermission('canViewClients')
  const canViewHolidays = () => hasPermission('canViewHolidays')
  const canViewParameters = () => hasPermission('canViewParameters')
  const canViewNewsletter = () => hasPermission('canViewNewsletter')
  const canViewGiftCard = () => hasPermission('canViewGiftCard')
  const canViewPromoCodes = () => hasPermission('canViewPromoCodes')
  const canViewPushNotification = () => hasPermission('canViewPushNotification')
  const canViewPlatformAlert = () => hasPermission('canViewPlatformAlert')
  const canManageUsers = () => hasPermission('canManageUsers')
  const canManageFinancialInstitutions = () => hasPermission('canManageFinancialInstitutions')
  const canViewBankerPromoCode = () => hasPermission('canViewBankerPromoCode')
  const canViewUserLogs = () => hasPermission('canViewUserLogs')
  const canViewAdminLogs = () => hasPermission('canViewAdminLogs')

  const hasInputAllowed = () => {
    return canManageOperation()
  }

  const hasSensitiveInputAllowed = () => {
    return canEditSensitiveInput()
  }

  return {
    canOpenMarket,
    canViewPlatformLogs,
    canCreatedData,
    canDeleteData,
    canEditData,
    canManageOperation,

    hasInputAllowed,
    hasSensitiveInputAllowed,

    canViewDashboard,
    canViewTargetTaxes,
    canViewPreOperations,
    canViewPostOperations,
    canViewCompletedOperations,
    canViewOperationLogs,
    canViewClients,
    canViewHolidays,
    canViewParameters,
    canViewNewsletter,
    canViewGiftCard,
    canViewPromoCodes,
    canViewPushNotification,
    canViewPlatformAlert,
    canManageUsers,
    canManageFinancialInstitutions,
    canViewBankerPromoCode,
    canViewUserLogs,
    canViewAdminLogs
  }
}
